export default __webpack_public_path__ + "static/media/Aiden1.bf9de056.jpg";